import React from 'react';
import { cloneDeep } from 'lodash-es';
import * as S from './ExcludeSettings.styled';
import { ChoosePublishers, ParagraphWithTooltip, CustomTooltip } from 'components';
import { Buttons } from 'components';
import { DeleteIcon, LockIcon } from 'assets/icons';

const ExcludePublishers = ({ onChange, onClear, value }) => {
  function handleClear() {
    if (onClear) {
      onClear('excluded_publishers');
      return;
    }
    onChange([]);
  }

  const deletePublisher = (id) => {
    let newPublishers = cloneDeep(value);
    newPublishers = newPublishers.filter((pub) => pub?.pb_number !== id);
    onChange(newPublishers);
  };

  const isSomeNotGlobal = value.some((item) => !item.isGlobal);

  return (
    <>
      <S.TextField>
        <S.Title>Exclude Publishers:</S.Title>
      </S.TextField>
      <S.FieldsWrap>
        <S.ActionField>
          <S.BtnWrap>
            <ChoosePublishers
              selectedPublishers={value}
              setSelectedPublishers={onChange}
              title='Exclude Publishers'
            />
          </S.BtnWrap>
          {value?.length > 0 && (
            <>
              <S.Line isNoButton={!isSomeNotGlobal} />
              {isSomeNotGlobal && (
                <S.BtnWrapp>
                  <Buttons.TertiaryNormal
                    id='categories_clear_all'
                    onClick={handleClear}
                    style={{ marginLeft: '16px' }}
                  >
                    Clear All
                  </Buttons.TertiaryNormal>
                </S.BtnWrapp>
              )}
              <S.Wrap>
                <S.SelectedItem>
                  {value?.map((item) => (
                    <S.Item key={item?.pb_number}>
                      <ParagraphWithTooltip text={item?.pb_name} />
                      {item.isGlobal ? (
                        <CustomTooltip content={<LockIcon />} text='General Exclude' />
                      ) : (
                        <S.IconWrapp onClick={() => deletePublisher(item?.pb_number)}>
                          <DeleteIcon />
                        </S.IconWrapp>
                      )}
                    </S.Item>
                  ))}
                </S.SelectedItem>
              </S.Wrap>
            </>
          )}
        </S.ActionField>
      </S.FieldsWrap>
    </>
  );
};

export default ExcludePublishers;
